module.exports = __webpack_public_path__ + "static/references-ae2356e2d534179b48e9928aa66598ff.svg";